/*
 * @Author: YuanYuan
 * @Date: 2024-02-07 16:16:44
 * @LastEditTime: 2025-12-12 10:58:59
 * @description: 资源管理路由定义
 */
import i18n from '@/i18n'

export default [
  {
    path: '/packages',
    meta: {
      title: i18n.t('menu.pkgMngmt'),
      leftMenuCode: 'Configurations'
    },
    component: () => import('@/views/packages/index.vue')
  }
]
